import styles from 'styles/Input.module.css'

const DateTimeInput = ({ register, name, label, methods,
    nolabel, ...rest }) => {
    // TODO: localize, Firefox support

    const input = <input id={name}
        name={name}
        type="date"
        className={styles.input}
        {...register(name)} />

    return nolabel
        ? input
        : (
            <label htmlFor={name}>
                <span className={styles.label_text} required={rest.required}>{ label || name }</span>
                { input}
            </label>
          )
}

export default DateTimeInput